<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="flex flex-wrap w-3/6 max-h-full bg-white shadow-lg rounded-lg px-5 pb-5 overflow-auto"
      >
        <div class="flex w-full flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div
              class="w-4/5 text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            >
              {{ currentProject.nombre }}
            </div>
            <div class="w-1/5 text-right">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>
        </div>
        <div class="w-full px-4 py-2 h-full">
          <div class="w-full">
            <div class="flex" v-if="showmap">
              <div class="h-80 w-full">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="4"
                  :center="center"
                  :options="{ zoomControl: false }"
                  @ready="onMapReady"
                >
                  <l-tile-layer
                    :url="urlBasemap"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-geo-json v-if="geojsonRouter" :geojson="geojsonRouter" />
                </l-map>
              </div>
            </div>
            <div class="flex w-full">
              <div
                class="flex flex-col w-full px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
              >
                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Nombre del proyecto:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.nombre }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Institución:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.institucion }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Nombre de quien propone:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.lider }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Descripción:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.descripcion }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Objetivo:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.objetivo }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold"
                      >Especificaciones multimedia:</span
                    >
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.especificaciones_multimedia }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Producto:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.producto }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === true"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Creado por:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.nombre_propietario }}
                    {{ currentProject.apellido_propietario }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === true"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Fecha de creación:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{
                      currentProject.fecha_creacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === false"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Desactivado por:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{ currentProject.nombre_curador_desactivate }}
                    {{ currentProject.apellido_curador_desactivate }}
                  </div>
                </div>

                <div
                  class="flex w-full text-xs pt-2 tracking-wide justify-center"
                  v-if="currentProject.activo === false"
                >
                  <div
                    class="w-4/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                  >
                    <span class="font-bold">Fecha de desactivación:</span>
                  </div>
                  <div
                    class="w-8/12 block tracking-wider text-gray-700 text-xs mb-2 text-justify"
                  >
                    {{
                      currentProject.fecha_desactivacion
                        | moment("DD/MM/YYYY hh:mm a")
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import L from "leaflet";
import { LMap, LGeoJson, LTileLayer } from "vue2-leaflet";

export default {
  name: "levantamiento-project-modal",
  data() {
    return {
      currentProject: {},
      report: null,
      information: null,
      showmap: false,
      errors: {
        report: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      zoom: 7,
      center: [20.58651, -89.01501],
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      geojsonRouter: null,
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    projectId: {
      required: true,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        this.fetchProject()
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },

  },
  // mounted() {
  //   EventBus.$on("showProjectDetailNew", this.setData);
  // },
  components: {
    LMap,
    LGeoJson,
    LTileLayer,
  },
  methods: {
    onMapReady: function () {
      this.$nextTick(() => {
        // removed console log
        const map = this.$refs.map.mapObject;
      });
    },

    reset: function () {
      this.showmap = false;
      this.geojsonRouter = null;
      (this.report = null),
        (this.information = null),
        (this.currentProject = {}),
        (this.errors = {
          report: false,
          codeError: "Ha ocurrido un error",
        });
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    // setData(data) {
    //   this.information = Object.assign({}, data);
    //   this.fetchProject();
    // },

    fetchProject() {
      this.axios
        .get(
          `apidev/projects/getInfoProject/${this.projectId}`,
          {},
          this.config
        )
        .then((response) => {
          // removed console log
          this.currentProject = response.data.answers;
          if (this.currentProject.geometria != null) {
            this.showmap = true;
            this.showPolygonInMap();
          } else {
            this.showmap = false;
          }
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    showPolygonInMap() {
      let that = this;
      if (this.currentProject.geometria !== null) {
        if (this.currentProject.kml != null) {
          const type = this.currentProject.kml.split(".")[1];
          if (type == "kml") {
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText);
            });
            oReq.open("GET", "apidev/" + this.currentProject.kml);
            oReq.send();
          }

          if (type == "kmz") {
            this.resetFileGeometryInMap();
            this.kmzParser.load("apidev/" + this.currentProject.kml);
          }
        } else {
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentProject.geometria;
          if (this.geojsonRouter) {
            let boundingBoxGeojson = L.geoJSON(this.geojsonRouter);
            let boundingBox = boundingBoxGeojson.getBounds();
            //this.$refs.map.mapObject.fitBounds(boundingBox);
            setTimeout(() => {
              that.$refs.map.mapObject.fitBounds(boundingBox);
            }, 500);
          }
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }
    },

    resetFileGeometryInMap() {
      if (this.layerKmz != null) {
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if (this.layerKml != null) {
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
